<template>
  <div class="tabs-wrapper">
    <b-tabs lazy>
      <b-tab title="1st vs. Other">
        <b-row>
          <b-col>
            <ulu-order-first-chart />
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Payment / Duration / Agent">
        <b-row>
          <b-col>
            <ulu-date-picker
              class="float-right m-1"
              range
              v-model="range"
              lang="en"
              format="DD.MM.YYYY"
              :placeholder="$t('globals.all')"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col style="max-width: 350px">
            <ulu-order-payment-type-chart :range="formatedRange" />
          </b-col>
          <b-col style="max-width: 350px">
            <ulu-order-payment-term-chart :range="formatedRange" />
          </b-col>
          <b-col style="max-width: 350px">
            <ulu-order-duration-chart :range="formatedRange" />
          </b-col>
          <b-col style="max-width: 350px">
            <ulu-order-agents-chart :range="formatedRange" />
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";

export default {
  components: {
    "ulu-order-first-chart": () =>
      import("@/components/dashboard/inquiry_order/OrderFirstChart.vue"),
    "ulu-date-picker": DatePicker,
    "ulu-order-payment-type-chart": () =>
      import("@/components/dashboard/inquiry_order/OrderPaymentTypeChart.vue"),
    "ulu-order-payment-term-chart": () =>
      import("@/components/dashboard/inquiry_order/OrderPaymentTermChart.vue"),
    "ulu-order-duration-chart": () =>
      import("@/components/dashboard/inquiry_order/OrderDurationChart.vue"),
    "ulu-order-agents-chart": () =>
      import("@/components/dashboard/inquiry_order/OrderAgentsChart.vue")
  },
  data() {
    return {
      range: [null, null],
      formatedRange: [null, null]
    }
  },
  watch: {
    range: function(newRange) {
      if (newRange[0] !== null && newRange[1] !== null) {
        let from = new Date(newRange[0]);
        let to = new Date(newRange[1]);

        from.setHours(from.getHours() + 1);
        to.setHours(to.getHours() + 25);

        this.formatedRange = [
          `${from.getFullYear()}-${from.getMonth()+1}-${from.getDate()}`,
          `${to.getFullYear()}-${to.getMonth()+1}-${to.getDate()}`
        ];
      } else {
        this.formatedRange = [null, null]
      }
    }
  }
};
</script>

<style scoped>
.tabs-wrapper >>> .nav-tabs {
  border-bottom: 1px solid #e0e0e0;
  background-color: white;
  padding: 0;
  margin-bottom: 0;
}

.tabs-wrapper >>> .nav-tabs .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
  color: #6c757d;
  font-size: 0.9375rem;
  font-weight: 500;
  padding: 1rem 1.5rem;
  background-color: transparent;
  transition: all 0.2s;
}

.tabs-wrapper >>> .nav-tabs .nav-link:hover {
  border-bottom-color: #ff6b35;
  color: #495057;
}

.tabs-wrapper >>> .nav-tabs .nav-link.active {
  color: #ff6b35;
  border-bottom-color: #ff6b35;
  background-color: white;
  font-weight: 600;
}

.tabs-wrapper >>> .tab-content {
  background-color: white;
  border: none;
  padding: 24px;
}

@media (max-width: 768px) {
  .tabs-wrapper >>> .nav-tabs .nav-link {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }

  .tabs-wrapper >>> .tab-content {
    padding: 16px;
  }
}
</style>
